import React, { useState } from "react";
import styled from "styled-components";

const Container = styled.div`
  position: fixed;
  bottom: 0px;
  right: 0px;
  background: #222;
  padding: 24px;
  margin-right: 12px;
  margin-bottom: 12px;
  border-radius: 3px;
  z-index: 10000;
  p {
    font-size: 22px;
  }

  button {
  }
`;

const COOKIE = "COOKIE";

function CookieNotification() {
  const [isShowing, setIsShowing] = useState(
    localStorage.getItem(COOKIE) !== "agreed",
  );

  if (!isShowing) {
    return null;
  }

  return (
    <Container>
      <p>We employ the use of cookies.</p>
      <button
        onClick={(e) => {
          e.preventDefault();
          localStorage.setItem(COOKIE, "agreed");
          setIsShowing(false);
        }}
      >
        Got it
      </button>
    </Container>
  );
}

export default CookieNotification;
